import React from 'react';
import { sendEvent } from 'shared/helpers/requests';
import styles from './FirstBlock.module.scss';
import { ReactComponent as LogoIcon } from '../../images/logo.svg';
import { ReactComponent as TitleIcon } from '../../images/title_icon.svg';
import { ReactComponent as StarIcon } from '../../images/star.svg';
import { ReactComponent as CheckIcon } from '../../images/check.svg';
import { BuyButton } from '../BuyButton';
import { PRICE } from '../../constants';

const TAGS = [
  'Закрепить изученное',
  'Поддержать интерес ребенка',
  'Расширить кругозор',
  'Изучить новые темы',
];
type Props = {
  isAfterBuy: boolean;
  goToUchiMain(): void;
  goToPayment(): void;
};

export function FirstBlock({ isAfterBuy, goToUchiMain, goToPayment }: Props) {
  const handleClickMainButton = () => {
    sendEvent({
      eventType: 'click_buy',
      eventSource: 'pryamyye_efiry_kak_kopit',
      eventInfo: JSON.stringify({ place: 'above' }),
    });
    goToPayment();
  };
  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={styles.content}>
        <LogoIcon className={styles.logo} onClick={goToUchiMain} />
        <h1 className={styles.title}>
          Прямые эфиры <br />
          для начальной школы
          <TitleIcon />
        </h1>
        <p className={styles.description}>
          <span>Интерактивные </span>
          онлайн-занятия с&nbsp;преподавателем
          <span />
        </p>
        <div className={styles.tags}>
          {TAGS.map((tag) => (
            <div key={tag} className={styles.tag}>
              <StarIcon />
              {tag}
            </div>
          ))}
        </div>
        <div className={styles.buttonWrapper}>
          {isAfterBuy ? (
            <>
              <p className={styles.afterBuyText}>
                Доступ оформлен <CheckIcon />
              </p>
              <p className={styles.afterBuyText}>
                Отправим ссылку на&nbsp;следующий эфир на&nbsp;email
              </p>
            </>
          ) : (
            <>
              <BuyButton onClick={handleClickMainButton} text="Оформить доступ" />
              <p className={styles.price}>{PRICE.priceForLesson}&nbsp;₽&nbsp;/ занятие</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
